<template>
  <div>
    <div class="transition">
      <cardless-base>
        <slot name="header">
          <PageTitle :title="title" />
        </slot>

        <b-row class="p-0 justify-content-center">
          <b-col sm="11">
            <b-row>
              <b-col sm="3" style="margin-top:10px">
                <RangeDatePicker
                  :initDate="initDate"
                  :endDate="endDate"
                  :isBusy="loading"
                  @selected="rangeDateSelected"
                  clearable
                />
              </b-col>

              <b-col sm="3" style="margin-top:10px">
                <GenericSelect
                  name="unidade"
                  ref="select-id_unidade"
                  labelKey="nome"
                  route="unidade"
                  v-model="unidade"
                  :disabled="loading"
                  @input="v => applyFilter('unidade', v)"
                  :firstOption="{ value: null, label: 'Unidade' }"
                ></GenericSelect>
              </b-col>
              <b-col sm="3" style="margin-top:10px">
                <b-form-select
                  ref="select-id_setor"
                  v-model="setor"
                  :disabled="loading"
                  :options="setores"
                  @input="v => applyFilter('setor', v)"
                />
              </b-col>
              <b-col sm="3" style="margin-top:10px">
                <b-form-select
                  v-model="statusProtocolo"
                  ref="select-status-protocolo"
                  :options="filterStatus"
                  :disabled="loading"
                  @input="v => applyFilter('finalizado', v)"
                />
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="1" style="margin-top:10px">
            <b-button
              v-if="!nofilters"
              @click="toggleFilters()"
              variant="none"
              class="btn toggle-button"
              :data-cy="`Adicionar ${name}`"
            >
              <SlidersIcon v-b-tooltip.hover.top="'Filtrar'" />
            </b-button>
          </b-col>
        </b-row>

        <TabelaProtocolo
          title="Lista de protocolos"
          :protocolos="protocol"
          :isBusy="loading"
          :tableFields="tableFields"
        />

        <nav
          aria-label="Navegar entre as páginas"
          class="paginador"
          v-if="protocol.length !== 0"
        >
          <div>Mostrando resultados {{ first }} a {{ last }}.</div>
          <ul class="justify-content-center mb-0">
            <b-pagination
              v-model="page"
              :total-rows="count"
              :per-page="rowsPerPage"
              hide-goto-end-buttons
            ></b-pagination>
          </ul>
        </nav>
      </cardless-base>
    </div>

    <b-sidebar
      v-model="showingFilters"
      id="sidebar"
      title="Filtros"
      shadow
      right
    >
      <b-container fluid>
        <b-row class="pt-4 pb-4">
          <b-col class="text-left">
            <b-button
              type="button"
              variant="none"
              class="sm secondary-contained-button"
              :disabled="loading"
              @click="resetFiltersValue"
              >Limpar</b-button
            >
          </b-col>
          <b-col class="text-right">
            <b-button
              type="button"
              variant="none"
              class="sm primary-light-contained-button"
              :disabled="loading"
              @click="handleSearch"
              >Buscar</b-button
            >
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-form-group label="Número do protocolo">
              <b-form-input
                v-model="protocoloFilter"
                autocomplete="off"
                class="invision-input sm"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-sidebar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import moment from 'moment';
import loginService from '@/services/login';

import GenericApi from '@/services/genericRequest';
import GenericSelect from '@/components/Form/GenericSelect';
import RangeDatePicker from '@/components/Form/RangeDatePicker';

import CardlessBase from '@/templates/CardlessBase';
import PageTitle from '@/templates/PageTitle';

import TabelaProtocolo from './TabelaProtocolo';

export default {
  name: 'Generic',
  components: {
    CardlessBase,
    PageTitle,
    TabelaProtocolo,
    GenericSelect,
    RangeDatePicker
  },
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    editRoute: {
      type: String,
      required: false
    },
    apiFunction: {
      type: String,
      required: false,
      default() {
        return 'get';
      }
    },
    api: {
      type: Object,
      required: false,
      default() {
        return GenericApi;
      }
    },
    canShowAllResults: {
      type: Boolean,
      default: false
    },
    permissionsToWrite: {
      type: Array,
      default() {
        return [];
      }
    },
    idKey: {
      type: String,
      default: ''
    },
    nofilters: {
      type: Boolean,
      default: false
    },
    noadd: {
      type: Boolean,
      default: false
    },
    editRouteIndex: {
      type: Function,
      default: () => 0
    },
    hasPagination: {
      type: Boolean,
      default: false
    },
    protocolos: {
      type: Array
    }
  },
  data() {
    return {
      lista: [],
      loading: false,
      errMsg: '',
      page: 1,
      rowsPerPage: 10,
      first: 0,
      last: 0,
      count: 0,
      protocol: [],
      setores: [
        {
          value: null,
          text: 'Setor'
        }
      ],
      tableFields: [],
      usuarioLogado: null,
      CAN_WRITE: loginService.verifyPermissions(this.permissionsToWrite),
      showingFilters: false,
      initDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
      unidade: null,
      setor: null,
      protocoloFilter: null,
      statusProtocolo: null,
      filters: {
        protocolo: null,
        unidade: null,
        setor: null,
        initDate: null,
        endDate: null,
        finalizado: null
      },
      filterStatus: [
        {
          value: null,
          text: 'Status'
        },
        {
          value: false,
          text: 'Pendente'
        },
        {
          value: true,
          text: 'Concluido'
        }
      ]
    };
  },
  watch: {
    async page(newValue) {
      await this.update(newValue);
    }
  },

  mounted() {
    this.usuarioLogado = loginService.getUser();
    this.loadSetores();
    this.update(this.page);
  },

  methods: {
    rangeDateSelected(initDate, endDate) {
      this.initDate = initDate;
      this.endDate = endDate;
      this.filters.initDate = initDate;
      this.filters.endDate = endDate;
      this.update();
    },

    async applyFilter(prop, value) {
      if (prop === 'unidade') {
        this.setor = null;
        this.filters = {
          ...this.filters,
          unidade: value,
          setor: null
        };
        await this.loadSetores();
      } else {
        this.filters[prop] = value;
      }
      if (this.page !== 1) this.page = 1;
      else this.update(this.page);
    },

    moment(date) {
      return moment(date);
    },

    async loadSetores() {
      this.loading = true;
      try {
        const params = {};
        if (this.unidade) {
          params.id_unidade = this.unidade;
        }
        const setores = await GenericApi.getAllWithoutPagination(
          params,
          'setor'
        );
        this.setores = [
          { text: 'Setor', value: null },
          ...setores.map(s => ({
            ...s,
            value: s.id_setor,
            text: s.nome
          }))
        ];
      } catch (error) {
        let errorMessage;
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          errorMessage = error.response.data.error.errorMessage;
        }
        console.log(error);
        swal({
          title: 'Oops!',
          text: errorMessage || 'Ocorreu um problema ao recuperar os setores',
          icon: 'warning',
          button: 'Continuar'
        });
      } finally {
        this.loading = false;
      }
    },

    async update(page) {
      this.loading = true;
      try {
        const { filters } = this;
        Object.keys(filters).forEach(key => {
          if (filters[key] === undefined || filters[key] === null)
            delete filters[key];
        });

        const protocol = await GenericApi.get(
          { page: page - 1, rowsPerPage: this.rowsPerPage, filters },
          'protocolo/listProtocolo'
        );
        this.first = (page - 1) * this.rowsPerPage + 1;
        this.last = page * this.rowsPerPage;
        this.count = protocol.count;
        this.protocol = protocol.rows;
        this.tableFields = protocol.tableFields;
      } catch (error) {
        let errorMessage;
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          errorMessage = error.response.data.error.errorMessage;
        }
        swal({
          title: 'Oops!',
          text:
            errorMessage || 'Ocorreu um problema ao recuperar os protocolos',
          icon: 'warning',
          button: 'Continuar'
        });
      } finally {
        this.loading = false;
      }
    },

    toggleFilters() {
      this.showingFilters = !this.showingFilters;
    },

    resetFiltersValue() {
      this.unidade = null;
      this.setor = null;
      this.initDate = null;
      this.endDate = null;
      this.statusProtocolo = null;
      this.protocoloFilter = null;
      this.filters = {
        protocolo: null,
        unidade: null,
        setor: null,
        initDate: null,
        endDate: null,
        statusProtocolo: null,
        finaliazado: null
      };
      if (this.page !== 1) this.page = 1;
      else this.update(this.page);
    },

    handleSearch() {
      console.log(this.protocoloFilter);
      if (this.protocoloFilter) this.filters.protocolo = this.protocoloFilter;
      if (this.page !== 1) this.page = 1;
      else this.update(this.page);
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-color-50: #209f85;
$primary-color-40: #21cca9;
$neutral-color-80: #35384d;
$neutral-color-70: #5e627a;
$neutral-color-60: #7e829f;

.invision-select {
  width: auto;

  color: #5e627a;
  background-color: #f0f1fc;

  border: none;
  margin-left: 12px;
}

.paginador {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
}

.feather {
  margin-bottom: 4px;
}
.spacer {
  margin-left: auto;
}

.transition {
  transition: 0.3s ease-in-out;
}

.toggle {
  margin-left: 14rem;
}

.toggle-button {
  color: $neutral-color-70;
}

label {
  color: $neutral-color-70;
}

.select-box {
  display: flex;
  width: 600px;
}

.invision-select,
.invision-input,
.invision-select.invision-input,
.form-control.invision-input,
.invision-file.invision-input .b-form-file.invision-input {
  margin-right: 1rem;
}

select:hover {
  border-color: #21cca9;
}

select:active,
select:focus,
select:hover {
  color: #21cca9;
}
</style>
